"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _Backdrop = _interopRequireDefault(require("../Backdrop"));

var _Card = _interopRequireDefault(require("../Card"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles(fullWidth, maxWidth) {
  var overflow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing,
      breakpoint = _useTheme.breakpoint;

  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    content: {
      overflow: overflow,
      width: fullWidth ? '100%' : 'auto',
      maxWidth: maxWidth ? "calc(".concat(breakpoint.values[maxWidth], "px - ").concat(spacing(16), ")") : "calc(100vw - ".concat(spacing(16), ")"),
      maxHeight: "calc(100vh - ".concat(spacing(16), ")"),
      '& > *': {
        margin: 'auto'
      }
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing, breakpoint }}", function () {
  return [_useTheme2["default"]];
});

var Dialog = function Dialog(props) {
  var _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 150 : _props$timeout,
      open = props.open,
      onClose = props.onClose,
      fullWidth = props.fullWidth,
      maxWidth = props.maxWidth,
      overflow = props.overflow,
      BackdropProps = props.BackdropProps,
      other = (0, _objectWithoutProperties2["default"])(props, ["timeout", "open", "onClose", "fullWidth", "maxWidth", "overflow", "BackdropProps"]);
  var classes = useStyles(fullWidth, maxWidth, overflow);
  return (0, _core.jsx)(_Backdrop["default"], (0, _extends2["default"])({
    open: open,
    timeout: timeout,
    onClose: onClose,
    containerProps: {
      className: /*#__PURE__*/(0, _emotion.css)(classes.root, ";label:className;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))
    }
  }, BackdropProps), (0, _core.jsx)(_Card["default"], (0, _extends2["default"])({
    css: classes.content,
    elevation: 5,
    color: "white"
  }, other)));
};

__signature__(Dialog, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Dialog;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/Dialog/index.tsx");
  reactHotLoader.register(Dialog, "Dialog", "/builds/bA1zbJom/0/gojob/ui-bits/src/Dialog/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Dialog/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();